(() => {
  const elems = document.querySelectorAll('#winches-form .input');
  for(let x = 0; x < elems.length; ++x) {
    elems[x].onkeyup = function() {
      this.value = (this.value.replace(/[^0-9]+/gi, ''));
    }
  }

  var winchesSelector = {
    step: 1,
    maxStep: 2,
    showStep: function(step) {
      document.querySelector('.winches-form .step-' + step).classList.add('active');
    },

    init: function() {
      var elems = document.querySelectorAll('.winches-selector .link');
      if (elems.length <= 0) {
        return;
      }
      var that = this;

      for (var x = 0; x < elems.length; ++x) {
        elems[x].onclick = function() {
          document.getElementById('winches-form').classList.add('active');
          that.showStep(1);
          if (document.querySelector('.winches-selector .link.active') !== null) {
            document.querySelector('.winches-selector .link.active').classList.remove('active');
          }
          this.classList.add('active');
          document.getElementById('winch-id').value = this.dataset.winchid;

          window.scrollTo({
            top: getBodyTopOffset(document.querySelector('#winches-form')) - 280,
            behavior: 'smooth',
          });
          return false;
        }
      }

      var button = document.querySelector('.winches-form .button');

      button.onclick = function() {
        if (that.step < that.maxStep) {
          ++that.step;
          that.showStep(that.step);
          return false;
        }
      }
    }
  };

  winchesSelector.init();

  document.querySelector('#select_winch_button').addEventListener('click', function (event) {
    event.preventDefault();

    window.scrollTo({
      top: getBodyTopOffset(document.querySelector('#section-winches')) - 120,
      behavior: 'smooth',
    });
  });

  document.querySelector('#about_us_link').addEventListener('click', (event) => {
    event.preventDefault();

    window.scrollTo({
      top: getBodyTopOffset(document.querySelector('#about_us')),
      behavior: 'smooth',
    });
  });

  function getBodyTopOffset(element) {
    let top = 0;

    do {
      top += element.offsetTop  || 0;
      element = element.offsetParent;
    } while(element);

    return top;
  }
})();
